import { render } from "./tradeOfferBuilder.vue?vue&type=template&id=4e29aab0&scoped=true"
import script from "./tradeOfferBuilder.vue?vue&type=script&lang=js"
export * from "./tradeOfferBuilder.vue?vue&type=script&lang=js"

import "./tradeOfferBuilder.vue?vue&type=style&index=0&id=4e29aab0&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e29aab0"]])

export default __exports__